import React, { useEffect, useState } from 'react';
import moment from 'moment';
import getTotalDbApiChecksByTariffPeriod from '../../resolvers/getTotalDbApiChecksByTariffPeriod';
import isPeriodDifferentByProducts from '../../resolvers/isPeriodDifferentByProducts';
import getBillingUnitsCount from '../../resolvers/getBillingUnitsCount';
import getAccountBonusByPeriod from '../../resolvers/getAccountBonusByPeriod';

export default function TableFooter({ product, total, discount, boltPrice }) {
    // dbChecks will be calculated only for productId = 2 (DB API).
    const dbChecks = getTotalDbApiChecksByTariffPeriod(product);
    const [licenseValidTill, setLicenseValidTill] = useState(null);
    const [bonusPeriod, setBonusPeriod] = useState('');

    useEffect(() => {
        if (product?.period?.license_valid_till) {
            setLicenseValidTill(moment(product?.period?.license_valid_till).format('MMM DD YYYY'));
        } else {
            setLicenseValidTill(moment()
                .add(product?.period?.interval, product?.period?.billing_period)
                .format('MMM DD YYYY'));
        }
        const bonusPeriodStructure = getAccountBonusByPeriod(product?.period);
        setBonusPeriod(bonusPeriodStructure ? bonusPeriodStructure?.label : '');
    }, [product?.period, product?.tariff]);

    return (
        <div className={'section__row section__row--border-top'}>
            <div className={'section__cell section__cell--name'}>
                {dbChecks > 0 && (
                    <p className={'text-3 mb-16 flex flex--column'}>
                        <span>Total available {dbChecks} checks</span>
                        <span className={'text-4 pt-2 color--gray'}>You can use any number of available spam checks without restrictions by months</span>
                    </p>
                )}
                <p className={'text-3 mb-3'}>
                    License period {moment().format('MMM DD YYYY')} -{' '}
                    {licenseValidTill}
                    {bonusPeriod && (
                        <span className={'text-3 color--brown'}> (includes additional {bonusPeriod})</span>
                    )}
                </p>
            </div>
            <div className={'section__cell section__cell--total'}>
                <div className={'flex flex--space-between'}>
                    <span className={'text-3'}>Total discount</span>
                    <span className={'text-3'}>{discount}</span>
                </div>
                <div className={'flex flex--space-between mt-10'}>
                    <span className={'text-3'}>Price</span>
                    <span className={`text-3 ${boltPrice ? 'bold' : ''}`}>{total}</span>
                </div>
            </div>
        </div>
    );
}
